import styled from 'styled-components'

export const ModalButton = styled.div`
    > Button {
        width: 100%;
        margin-top: 20px;
    }
`

export const Content = styled.div`
    size: 16px;
    line-height: 25px;

    > ol > li > .content_fade {
        color: #898f99;
    }
    > * a {
        color: ${({ theme }) => theme.colors.brand.primary};
    }
`
